import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { CmsService, TranslatePipe } from '@spartacus/core';
import { Observable, Subscription, combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { PermissionsConstants } from 'src/app/service/myaccount/my-account-permission.constants';
import { MyAccountPermissionService } from 'src/app/service/myaccount/my-account-permission.service';
import { MyaccountB2bunitService } from 'src/app/service/myaccount/myaccount-b2bunit.service';

@Component({
  selector: 'app-myaccount-payment-details',
  templateUrl: './myaccount-payment-details.component.html',
  styleUrls: ['./myaccount-payment-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [AsyncPipe, TranslatePipe],
})
export class MyaccountPaymentDetailsComponent implements OnInit {
  myaccountPaymentDetails$: Observable<any>;
  myaccountPaymentDetailsLoaded$: Subscription;
  myAccountPermissionSubscription: Subscription;
  showCreditInfo: boolean;

  constructor(
    private myAccountB2BUnitService: MyaccountB2bunitService,
    protected cms: CmsService,
    private cdr: ChangeDetectorRef,
    private myAccountPermissionService: MyAccountPermissionService
  ) {}

  ngOnInit() {
    this.myaccountPaymentDetailsLoaded$ = combineLatest([this.isAccountPage$(), this.getB2BManagement()]).subscribe(
      ([isAccountPage, b2bManagement]) => {
        if (isAccountPage && b2bManagement) {
          this.myaccountPaymentDetails$ = of(b2bManagement);
          this.myAccountB2BUnitService.isPaymentDetailsLoaded.next(true);
        }

        this.checkCreditInfo();
        if (!(this.cdr as ViewRef).destroyed) {
          this.cdr.detectChanges();
        }
      }
    );
  }

  private getB2BManagement(): Observable<any> {
    return this.myAccountB2BUnitService.getB2BManagement();
  }

  isAccountPage$(): Observable<boolean> {
    return this.cms
      .getCurrentPage()
      .pipe(map((currentPage) => currentPage && currentPage.label.includes('/my-account')));
  }

  checkCreditInfo() {
    let myAccountInfo = document.getElementsByClassName('AccountInfo')[0] as HTMLElement;
    let myAccountPaymentDetails = document.querySelector(`app-myaccount-payment-details`);

    this.myAccountPermissionSubscription = this.myAccountPermissionService.currentUserPermissions$.subscribe(
      (permissions: any) => {
        if (permissions && permissions.includes(PermissionsConstants.VIEW_CREDIT_INFO)) {
          this.showCreditInfo = true;
          myAccountPaymentDetails.classList.add('has-credit-info');
          myAccountInfo.classList.add('show-credit-info');
        }
        this.cdr.markForCheck();
      }
    );
  }

  ngOnDestroy() {
    this.myaccountPaymentDetailsLoaded$?.unsubscribe();
    this.myAccountPermissionSubscription?.unsubscribe();
  }
}
